import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const OrganizationFragment = () => {
    const [companies, setCompanies] = useState([]);
    const [categorys, setCategorys] = useState([]);
    const [isList, setIsList] = useState(true);
    const [isRequests, setIsRequests] = useState(true);
    const [isOnboarding, setIsOnboarding] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(7);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [requests, setRequests] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        dataLocation: 'india',
        description: '',
        category: '',
        userID: localStorage.getItem('userId'), // Assuming you have the userID
        logoFile: null,
        country: '',
        city: '',
        employees: 1,
        isManaged: true,
        platform: 'both',
        contactExpiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        renewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        companyDomain: '',
        smtpEmail: '',
        smtpPassword: '',
        smtpPort: '',
        smtpHost: '',
        username: '',
        permissions: [] // New state for permissions
    });

    const [formDataOnboard, setFormDataOnboard] = useState({
        name: '',
        dataLocation: 'india',
        description: '',
        category: '',
        userID: localStorage.getItem('userId'), // Assuming you have the userID
        logoFile: null,
        country: '',
        city: '',
        employees: 1,
        isManaged: true,
        platform: 'both',
        contactExpiryDate: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().split('T')[0],
        renewalDate: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().split('T')[0],
        companyDomain: '',
        smtpEmail: '',
        smtpPassword: '',
        smtpPort: '',
        smtpHost: '',
        username: '',
        permissions: [] // New state for permissions
    });

    useEffect(() => {
        fetchCategorys();
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch(`https://beiguru.co.in/admin/pending-requests`, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                console.log(result);
                setRequests(result);
            })
            .catch((error) => console.error(error));
    }


    useEffect(() => {
        fetchCompanies(currentPage);
    }, [currentPage, itemsPerPage]);

    const fetchCategorys = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categoryCompany", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setCategorys(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCompanies = async (page) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch(`https://beiguru.co.in/admin/all-companies?page=${page}&limit=${itemsPerPage}`, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                setCompanies(result.companies);
                setTotalPages(result.totalPages);
                setCurrentPage(result.currentPage);
            })
            .catch((error) => console.error(error));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const companyResponse = await fetch('https://beiguru.co.in/admin/create-company', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${localStorage.getItem('token')}` // Assuming token is stored in localStorage
                },
                body: JSON.stringify({
                    companyName: formData.name ?? '',
                    description: formData.description ?? '',
                    category: formData.category ?? '',
                    userID: formData.userID ?? '',
                    country: formData.country ?? '',
                    city: formData.city ?? '',
                    employees: formData.employees ?? '',
                    companyDomain: formData.companyDomain ?? '',
                    smtpEmail: formData.smtpEmail ?? '',
                    smtpPassword: formData.smtpPassword ?? '',
                    smtpPort: formData.smtpPort ?? '',
                    smtpHost: formData.smtpHost ?? '',
                    username: formData.username ?? '',
                    permissions: formData.permissions ?? '',
                    isManaged: formData.isManaged ?? '',
                    platform: formData.platform ?? '',
                    contactExpiryDate: formData.contactExpiryDate ?? '',
                    renewalDate: formData.renewalDate ?? '',
                })
            });
            console.log(companyResponse);
            if (!companyResponse.ok) {
                throw new Error('Failed to add organization');
            }

            const companyData = await companyResponse.json();
            if (formData.logoFile) {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));

                const formdata = new FormData();
                formdata.append("logo", formData.logoFile, formData.logoFile.name);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                const logoResponse = await fetch(`https://beiguru.co.in/admin/upload-logo/${companyData.company._id}`, requestOptions);

                if (!logoResponse.ok) {
                    throw new Error('Failed to upload logo');
                }

            }

            setFormData({
                name: '',
                description: '',
                category: '',
                userID: localStorage.getItem('userId'), // Assuming you have the userID
                logoFile: null,
                country: '',
                city: '',
                employees: 1,
                isManaged: true,
                platform: 'both',
                contactExpiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                renewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                companyDomain: '',
                smtpEmail: '',
                smtpPassword: '',
                smtpPort: '',
                smtpHost: '',
                permissions: []
            });
            alert('Organization created successfully');
            await fetchCompanies();
            setIsLoading(false);
            setIsList(true);
        } catch (error) {
            alert('There was a error creating organization, please try again.');
            setIsLoading(false);
        }
    };


    const handleOnboard = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const companyResponse = await fetch('https://beiguru.co.in/admin/onboard-company', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${localStorage.getItem('token')}` // Assuming token is stored in localStorage
                },
                body: JSON.stringify({
                    companyName: formDataOnboard.name,
                    description: formDataOnboard.description,
                    category: formDataOnboard.category,
                    userID: formDataOnboard.userID,
                    country: formDataOnboard.country,
                    city: formDataOnboard.city,
                    employees: formDataOnboard.employees,
                    companyDomain: formDataOnboard.companyDomain,
                    smtpEmail: formDataOnboard.smtpEmail,
                    smtpPassword: formDataOnboard.smtpPassword,
                    smtpPort: formDataOnboard.smtpPort,
                    smtpHost: formDataOnboard.smtpHost,
                    username: formDataOnboard.username,
                    permissions: formDataOnboard.permissions,
                    isManaged: formDataOnboard.isManaged,
                    platform: formDataOnboard.platform,
                    trailID: formDataOnboard.trailID,
                    contactExpiryDate: formDataOnboard.contactExpiryDate,
                    renewalDate: formDataOnboard.renewalDate,
                })
            });
            console.log(companyResponse);
            if (!companyResponse.ok) {
                throw new Error('Failed to add organization');
            }

            const companyData = await companyResponse.json();
            if (formData.logoFile) {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));

                const formdata = new FormData();
                formdata.append("logo", formData.logoFile, formData.logoFile.name);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                const logoResponse = await fetch(`https://beiguru.co.in/admin/upload-logo/${companyData.company._id}`, requestOptions);

                if (!logoResponse.ok) {
                    throw new Error('Failed to upload logo');
                }

            }

            setFormDataOnboard({
                name: '',
                description: '',
                category: '',
                userID: localStorage.getItem('userId'), // Assuming you have the userID
                logoFile: null,
                country: '',
                city: '',
                employees: 1,
                isManaged: true,
                platform: 'both',
                contactExpiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                renewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                companyDomain: '',
                smtpEmail: '',
                smtpPassword: '',
                smtpPort: '',
                smtpHost: '',
                permissions: []
            });
            alert('Organization onboarded successfully');
            await fetchRequests();
            await fetchCompanies();
            setIsLoading(false);
            setIsOnboarding(false);
            setIsRequests(true);
            setIsList(true);
        } catch (error) {
            alert('There was a error creating organization, please try again.');
            setIsLoading(false);
        }
    };


    const handleFileChange = (e) => {
        setFormData({ ...formData, logoFile: e.target.files[0] });
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleEdit = (course) => {
        setFormData({
            name: course.name ?? '',
            description: course.description ?? '',
            category: course.category._id ?? '',
            userID: localStorage.getItem('userId') ?? '', // Assuming you have the userID
            country: course.country ?? '',
            city: course.city ?? '',
            employees: course.employees ?? '',
            companyDomain: course.companyDomain ?? '',
            smtpEmail: course.smtpEmail ?? '',
            smtpPassword: course.smtpPassword ?? '',
            smtpPort: course.smtpPort ?? '',
            smtpHost: course.smtpHost ?? '',
            username: course.users[0] ? course.users[0].username : '',
            permissions: course.users[0] ? course.users[0].permissions : '',
            isManaged: course.isManaged ?? '',
            platform: course.platform ?? '',
            demo: course.demo ?? '',
            contactExpiryDate: course.contactExpiryDate ? new Date(course.contactExpiryDate).toISOString().split('T')[0] : '',
            renewalDate: course.renewalDate ? new Date(course.renewalDate).toISOString().split('T')[0] : '',
            _id: course._id
        });
        setIsEdit(true);
        setIsList(false);
    };

    const handleModify = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const companyResponse = await fetch(`https://beiguru.co.in/admin/company/${formData._id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') // Replace with your JWT token
                },
                body: JSON.stringify({
                    companyName: formData.name,
                    description: formData.description,
                    category: formData.category,
                    userID: formData.userID,
                    country: formData.country,
                    city: formData.city,
                    employees: formData.employees,
                    companyDomain: formData.companyDomain,
                    smtpEmail: formData.smtpEmail,
                    smtpPassword: formData.smtpPassword,
                    smtpPort: formData.smtpPort,
                    smtpHost: formData.smtpHost,
                    username: formData.username,
                    permissions: formData.permissions,
                    isManaged: formData.isManaged,
                    platform: formData.platform,
                    removeDemo: formData.removeDemo,
                    contactExpiryDate: formData.contactExpiryDate,
                    renewalDate: formData.renewalDate,
                })
            });

            if (!companyResponse.ok) {
                throw new Error('Failed to add organization');
            }

            if (formData.logoFile) {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));

                const formdata = new FormData();
                formdata.append("logo", formData.logoFile, formData.logoFile.name);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };

                const logoResponse = await fetch(`https://beiguru.co.in/admin/upload-logo/${formData._id}`, requestOptions);

                if (!logoResponse.ok) {
                    throw new Error('Failed to upload logo');
                }

            }
            setFormData({
                name: '',
                description: '',
                category: '',
                userID: localStorage.getItem('userId'), // Assuming you have the userID
                logoFile: null,
                country: '',
                city: '',
                employees: 1,
                isManaged: true,
                platform: 'both',
                contactExpiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                renewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                companyDomain: '',
                smtpEmail: '',
                smtpPassword: '',
                smtpPort: '',
                smtpHost: '',
                permissions: []
            });
            alert('Organization updated successfully');
            await fetchCompanies();
            setIsLoading(false);
            setIsList(true);
        } catch (error) {
            alert('There was a error updating organization, please try again.');
            setIsLoading(false);
        }
    };

    const handleReject = async (courseId) => {
        const isConfirmed = window.confirm("Are you sure you want to reject this request? A rejection mail will be sent to the admin!");

        if (!isConfirmed) return;
        try {
            const token = localStorage.getItem('token');
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': token },
            };
            const response = await fetch(`https://beiguru.co.in/admin/reject-request/${courseId}`, requestOptions);
            if (response.ok) {
                alert('Request rejected successfully');
                await fetchRequests();
                await fetchCompanies();
                setIsLoading(false);
                setIsOnboarding(false);
                setIsRequests(true);
                setIsList(true);
            } else {
                throw new Error('Failed to upload logo');
            }
        } catch (error) {
            console.error('Error modify organization:', error);
            alert('Failed to reject request');
        }
    }


    const handleDelete = async (courseId) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to delete this organization?");

        if (!isConfirmed) return; // If user cancels, do nothing

        try {
            const token = localStorage.getItem('token'); // Get the authentication token
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': token },
            };

            const response = await fetch(`https://beiguru.co.in/company/${courseId}`, requestOptions);

            if (response.ok) {
                alert('Organization deleted successfully');
                fetchCompanies();
            } else {
                throw new Error('Failed to upload logo');
            }
        } catch (error) {
            console.error('Error modify organization:', error);
            alert('Failed to modify organization');
        }
    };

    const handlePermissionsChange = (e) => {
        const { value } = e.target;
        let updatedPermissions = [...formData.permissions];

        if (updatedPermissions.includes(value)) {
            updatedPermissions = updatedPermissions.filter(permission => permission !== value);
        } else {
            updatedPermissions.push(value);
        }

        setFormData({ ...formData, permissions: updatedPermissions });
    };

    return (<Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Container fluid style={{ height: '100%' }}>
            <div style={{ marginBottom: '15px', justifyContent: 'space-between', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row' }}>{isList ? <h4>All Organization</h4> : isEdit ? <h4>Edit Organization</h4> : <h4>Create Organization</h4>}
                <div style={{ flex: 1 }} />
                {/* {isList ? <Button
                    style={{ fontWeight: '600', borderRadius: '20px', marginRight: '10px' }}
                    elevation={3}
                    className="w-10"
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={(event) => {
                        setIsRequests(!isRequests);
                        setIsOnboarding(false);
                    }}>
                    {isRequests ? 'Pending Requests' : 'Cancel'}
                </Button> : null} */}
                {isRequests ? <Button
                    style={{ fontWeight: '600', borderRadius: '20px' }}
                    elevation={3}
                    className="w-10"
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={(event) => {
                        event.preventDefault();
                        setFormData({
                            name: '',
                            description: '',
                            category: '',
                            userID: localStorage.getItem('userId'), // Assuming you have the userID
                            logoFile: null,
                            country: '',
                            city: '',
                            employees: 1,
                            isManaged: true,
                            platform: 'both',
                            contactExpiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                            renewalDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                            companyDomain: '',
                            smtpEmail: '',
                            smtpPassword: '',
                            smtpPort: '',
                            smtpHost: '',
                            permissions: []
                        });
                        setIsEdit(false);
                        setIsList(!isList);
                    }}>
                    {isList ? 'Create Organization' : 'Cancel'}
                </Button> : null}</div>
            <Row>
                {isRequests ? isList ? <Col xs={12} style={{ flex: 1, height: '83vh', overflowY: 'scroll', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        {companies.length > 0 ? <Table striped bordered hover >
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Logo</th>
                                    <th>Name</th>
                                    <th>City, Country</th>
                                    <th>Renewal/Contract Date</th>
                                    <th>Platform</th>
                                    <th>Is Managed</th>
                                    <th>Category</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {companies.map((company, index) => (<tr key={company._id}>
                                    <td style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}><div style={{
                                        backgroundColor: company.demo ? 'orange' : company.active ? 'green' : 'red',
                                        width: '10px',
                                        height: '50px'
                                    }} />{index + 1}</td>
                                    <td><img
                                        src={`https://beiguru.co.in/${company.logo}`}
                                        height="50"
                                        className="d-inline-block align-center"
                                        alt="Logo"
                                    /></td>
                                    <td>{company.name}<p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{company._id}</p></td>
                                    <td>{company.city}, {company.country}</td>
                                    <td>{new Date(company.renewalDate).toDateString()}<p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{new Date(company.contactExpiryDate).toDateString()}</p></td>
                                    <td>{company.platform}</td>
                                    <td>{company.isManaged ? 'Yes' : 'No'}</td>
                                    <td>{company.category.name}</td>
                                    <td>
                                        <EditNoteIcon onClick={() => handleEdit(company)} style={{ color: 'blue', cursor: 'pointer' }} />
                                        <DoDisturbIcon onClick={() => handleDelete(company._id)} style={{ color: 'blue', cursor: 'pointer' }} />
                                    </td>
                                </tr>))}
                            </tbody>
                        </Table> : <div style={{ margin: '20px', textAlign: 'center' }}>No organization found, please try again!</div>}
                    </div>
                    <div style={{ flex: 1 }} />
                    <nav aria-label="Courses pagination">
                        <ul className="pagination" style={{ display: 'flex', alignItems: 'center' }}>
                            <li className="page-item">
                                <select
                                    className="form-select form-select-sm"
                                    aria-label="Default select example"
                                    value={itemsPerPage}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setItemsPerPage(parseInt(e.target.value));
                                    }}
                                    style={{ height: '40px' }} // Set the height to 100%
                                >
                                    <option value="7">7 per page</option>
                                    <option value="10">10 per page</option>
                                    <option value="50">50 per page</option>
                                    <option value="100">100 per page</option>
                                </select>
                            </li>
                            <div style={{ width: '10px' }} />
                            {[...Array(totalPages).keys()].map((page) => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </Col> : <Row xs={12} style={{ flex: 1, height: '83vh', overflowY: 'scroll' }}>
                    <Col xs={6}>
                        <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                            <Form.Group controlId="formCompanyName">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Organization Name<span style={{ color: 'red' }}> *</span></Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization name"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyDescription">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Description</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter organization description"
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyCategory">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category<span style={{ color: 'red' }}> *</span></Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    value={formData.category}
                                    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                >
                                    <option value="">Select a category</option>
                                    {categorys.map(material => (
                                        <option key={material._id} value={material._id}>{material.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formSmtpEmail">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>SMTP Email</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="email"
                                    placeholder="Enter SMTP email"
                                    value={formData.smtpEmail}
                                    onChange={(e) => setFormData({ ...formData, smtpEmail: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formSmtpPassword">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>SMTP Password</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="password"
                                    placeholder="Enter SMTP password"
                                    value={formData.smtpPassword}
                                    onChange={(e) => setFormData({ ...formData, smtpPassword: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formSmtpPort">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>SMTP Port</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="number"
                                    placeholder="Enter SMTP port"
                                    value={formData.smtpPort}
                                    onChange={(e) => setFormData({ ...formData, smtpPort: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formSmtpHost">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>SMTP Host</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter SMTP host"
                                    value={formData.smtpHost}
                                    onChange={(e) => setFormData({ ...formData, smtpHost: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyPlatform">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Platform<span style={{ color: 'red' }}> *</span></Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    value={formData.platform}
                                    onChange={(e) => setFormData({ ...formData, platform: e.target.value })}>
                                    <option value="phone">Phone</option>
                                    <option value="web">Web</option>
                                    <option value="both">Both</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formCompanyPlatform">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Data Location</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    disabled
                                    value={formData.dataLocation}
                                    onChange={(e) => setFormData({ ...formData, dataLocation: e.target.value })}>
                                    <option value="india">India</option>
                                    <option value="america">America</option>
                                    <option value="singapore">Singapore</option>
                                </Form.Control>
                            </Form.Group>
                        </Form>
                    </Col>
                    <Col xs={6}>
                        <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                            <Form.Group controlId="formCompanyCountry">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Country</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization country"
                                    value={formData.country}
                                    onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyCity">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>City</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization city"
                                    value={formData.city}
                                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyEmployees">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Students Limit</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="number"
                                    placeholder="Enter number of students"
                                    value={formData.employees}
                                    onChange={(e) => setFormData({ ...formData, employees: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyLogo">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Upload Logo</Form.Label>
                                <Form.Control
                                    type="file"
                                    className="w-100"
                                    placeholder="Select Logo"
                                    accept=".png"
                                    onChange={handleFileChange}
                                    style={{ width: '100%', borderRadius: '20px' }}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyDomain">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Organization Domain</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter company domain"
                                    value={formData.companyDomain}
                                    onChange={(e) => setFormData({ ...formData, companyDomain: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formSmtpEmail">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Admin Email</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="email"
                                    placeholder="Enter admin email"
                                    value={formData.username}
                                    onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="dueDate">
                                <Form.Label>Contact Expiry Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.contactExpiryDate}

                                    onChange={(e) => setFormData({ ...formData, contactExpiryDate: e.target.value })}
                                    required
                                    style={{ width: '100%', borderRadius: '20px' }}
                                />
                            </Form.Group>
                            <Form.Group controlId="dueDate">
                                <Form.Label>Renewal Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.renewalDate}
                                    onChange={(e) => setFormData({ ...formData, renewalDate: e.target.value })}
                                    required
                                    style={{ width: '100%', borderRadius: '20px' }}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyIsManaged">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Is Managed</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    checked={formData.isManaged}
                                    onChange={(e) => setFormData({ ...formData, isManaged: e.target.checked, permissions: ['dashboard'] })}
                                    label="Is this company managed?"
                                />
                            </Form.Group>
                            {formData.demo ? <Form.Group controlId="formCompanyIsManaged">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Demo</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    checked={formData.removeDemo}
                                    onChange={(e) => setFormData({ ...formData, removeDemo: e.target.checked })}
                                    label="This organization is under demo. Would you like to enroll this organization?"
                                />
                            </Form.Group> : null}
                            {formData.isManaged ? null : <Form.Group controlId="permissions" style={{ marginTop: '10px' }}>
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Permissions:</Form.Label>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: '10px' }}>
                                    <div>
                                        <Form.Check
                                            type="checkbox"
                                            label="All"
                                            name="permissions"
                                            value="all"
                                            checked={formData.permissions.includes("all")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Dashboard"
                                            name="permissions"
                                            value="dashboard"
                                            checked={formData.permissions.includes("dashboard")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Students"
                                            name="permissions"
                                            value="employee"
                                            checked={formData.permissions.includes("employee")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Course"
                                            name="permissions"
                                            value="course"
                                            checked={formData.permissions.includes("course")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Quiz"
                                            name="permissions"
                                            value="quiz"
                                            checked={formData.permissions.includes("quiz")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                    </div>
                                    <div>
                                        <Form.Check
                                            type="checkbox"
                                            label="Rating"
                                            name="permissions"
                                            value="rating"
                                            checked={formData.permissions.includes("rating")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Answers"
                                            name="permissions"
                                            value="answers"
                                            checked={formData.permissions.includes("answers")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Survey"
                                            name="permissions"
                                            value="survey"
                                            checked={formData.permissions.includes("survey")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Info"
                                            name="permissions"
                                            value="info"
                                            checked={formData.permissions.includes("info")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Notification"
                                            name="permissions"
                                            value="notification"
                                            checked={formData.permissions.includes("notification")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                    </div>
                                </div>
                            </Form.Group>}
                        </Form>
                    </Col>
                    <Col xs={12} style={{ marginBottom: '10px', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                        <Button
                            onClick={isEdit ? handleModify : handleSubmit}
                            style={{ fontWeight: '600', borderRadius: '20px', marginTop: '15px' }}
                            elevation={3}
                            className="w-25"
                            variant="primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : null}
                            {isEdit ? 'Edit Organization' : 'Create Organization'}
                        </Button>
                    </Col>
                </Row> : isOnboarding ? <Row xs={12} style={{ flex: 1, height: '83vh', overflowY: 'scroll' }}>
                    <Col xs={6}>
                        <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                            <Form.Group controlId="formCompanyName">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Organization Name</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization name"
                                    value={formDataOnboard.name}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, name: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyCategory">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    value={formDataOnboard.category}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, category: e.target.value })}
                                >
                                    <option value="">Select a category</option>
                                    {categorys.map(material => (
                                        <option key={material._id} value={material._id}>{material.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formCompanyCity">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>City</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization city"
                                    value={formDataOnboard.city}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, city: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyCity">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>City</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter organization country"
                                    value={formDataOnboard.country}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, country: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyPlatform">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Data Location</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    disabled
                                    value={formDataOnboard.dataLocation}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, dataLocation: e.target.value })}>
                                    <option value="india">India</option>
                                    <option value="america">America</option>
                                    <option value="singapore">Singapore</option>
                                </Form.Control>
                            </Form.Group>
                        </Form>
                    </Col>
                    <Col xs={6}>
                        <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                            <Form.Group controlId="formSmtpEmail">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Admin Email</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="email"
                                    placeholder="Enter admin email"
                                    value={formDataOnboard.username}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, username: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyEmployees">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Students Limit</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="number"
                                    placeholder="Enter number of students"
                                    value={formDataOnboard.employees}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, employees: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCompanyDomain">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Organization Domain</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter company domain"
                                    value={formDataOnboard.companyDomain}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, companyDomain: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="dueDate">
                                <Form.Label>Contact Expiry Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formDataOnboard.contactExpiryDate}

                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, contactExpiryDate: e.target.value })}
                                    required
                                    style={{ width: '100%', borderRadius: '20px' }}
                                />
                            </Form.Group>
                            <Form.Group controlId="dueDate">
                                <Form.Label>Renewal Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formDataOnboard.renewalDate}
                                    onChange={(e) => setFormDataOnboard({ ...formDataOnboard, renewalDate: e.target.value })}
                                    required
                                    style={{ width: '100%', borderRadius: '20px' }}
                                />
                            </Form.Group>
                        </Form>
                    </Col>
                    <Col xs={12} style={{ marginBottom: '10px', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                        <Button
                            onClick={handleOnboard}
                            style={{ fontWeight: '600', borderRadius: '20px', marginTop: '15px' }}
                            elevation={3}
                            className="w-25"
                            variant="primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : null}
                            Onboard Organization
                        </Button>
                    </Col>
                </Row> : <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email / Mobile</th>
                            <th>Org. Name / NofE</th>
                            <th>Location</th>
                            <th>Awareness Type / Language</th>
                            <th>Training Timeframe</th>
                            <th>Existing Platform / Platform Issues</th>
                            <th>Additional Info</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requests.map((request) => (
                            <tr key={request._id}>
                                <td>{request.firstName} {request.lastName}</td>
                                <td>{request.officialEmail}<p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>{request.contactNumber}</p></td>
                                <td>{request.organizationName}<p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>({request.numberOfEmployees})</p></td>
                                <td>{request.city}, {request.country}</td>
                                <td>{request.awarenessType}<p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>({request.language})</p></td>
                                <td>{request.trainingTimeframe}</td>
                                <td>{request.existingPlatform}<p style={{ margin: '0px', padding: '0px', fontSize: '14px' }}>({request.platformIssues})</p></td>
                                <td>{request.additionalInfo}</td>
                                <td>
                                    <IconButton
                                        color="success"
                                        onClick={() => {
                                            setFormDataOnboard({
                                                name: request.organizationName,
                                                description: '',
                                                category: request.category,
                                                userID: localStorage.getItem('userId'), // Assuming you have the userID
                                                country: request.country,
                                                city: request.city,
                                                employees: 10,
                                                companyDomain: request.companyDomain,
                                                smtpEmail: '',
                                                smtpPassword: '',
                                                smtpPort: '',
                                                smtpHost: '',
                                                username: request.officialEmail,
                                                permissions: ['dashboard', 'employee'],
                                                isManaged: false,
                                                platform: 'both',
                                                trailID: request._id,
                                                contactExpiryDate: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().split('T')[0],
                                                renewalDate: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().split('T')[0],
                                            });
                                            setIsOnboarding(true);
                                        }}>
                                        <CheckCircleIcon style={{ color: 'green' }} />
                                    </IconButton>
                                    {' '}
                                    <IconButton
                                        color="error"
                                        onClick={() => handleReject(request._id)}>
                                        <CancelIcon style={{ color: 'red' }} />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>}
            </Row>
        </Container>
    </Grid >
    );
}

export default OrganizationFragment;